/* House of Sneakers: Verfuegbarkeit je Markt (US/UK) auf Produktseite und im Warenkorb. */
(function () {
  var el = document.getElementById('hos-markt-daten');
  if (!el) return;
  var d;
  try { d = JSON.parse(el.textContent); } catch (e) { return; }
  var key = d.key, V = d.variants || {}, T = d.texts || {}, onCart = d.page === 'cart';

  function entry(id) { return V[String(id)] || null; }
  function blocked(id) {
    var e = entry(id);
    if (!e) return false;                       // fremde Variante (nicht auf dieser Seite) -> nicht anfassen
    return !(e.info && e.info[key] === true);   // ohne Angabe oder ohne Angebot -> gesperrt
  }
  function sizeText(id) {
    var e = entry(id);
    if (!e || !e.info || !e.info.us_size) return '';
    var t = 'EU ' + e.eu + ' = US ' + e.info.us_size;
    if (key === 'UK' && e.info.uk_size) t += ' (UK ' + e.info.uk_size + ')';
    return t;
  }
  function setDisabled(btn, on) {
    if (on) { btn.setAttribute('data-hos-blocked', '1'); btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); }
    else if (btn.getAttribute('data-hos-blocked')) { btn.removeAttribute('data-hos-blocked'); btn.disabled = false; btn.removeAttribute('aria-disabled'); }
  }
  function updateForm(form) {
    var inp = form.querySelector('[name="id"]');
    if (!inp || !entry(inp.value)) return;
    var b = blocked(inp.value);
    form.querySelectorAll('button[type="submit"], button[name="add"], [data-add-to-cart]').forEach(function (btn) { setDisabled(btn, b); });
    var pay = form.querySelector('.shopify-payment-button');
    if (pay) pay.style.display = b ? 'none' : '';
    var note = form.querySelector('.hos-markt-hinweis');
    if (!note) { note = document.createElement('p'); note.className = 'hos-markt-hinweis'; form.appendChild(note); }
    note.textContent = b ? T.blocked : '';
    note.classList.toggle('is-blocked', b);
    note.style.display = note.textContent ? '' : 'none';
  }
  function updateCart() {
    if (!onCart) return;
    var bad = Object.keys(V).filter(blocked);
    if (!bad.length) return;
    document.querySelectorAll('[name="checkout"], button[form][name="checkout"], .cart__checkout-button').forEach(function (btn) { setDisabled(btn, true); });
    if (!document.querySelector('.hos-markt-hinweis.is-cart')) {
      var host = document.querySelector('form[action$="/cart"]');
      if (host) {
        var n = document.createElement('p');
        n.className = 'hos-markt-hinweis is-blocked is-cart';
        n.textContent = T.cart;
        host.insertBefore(n, host.firstChild);
      }
    }
  }
  // Das Theme haengt an Preise in den Groessen-Kaestchen fest ein "€" an - im US/UK-Markt durch $ bzw. £ ersetzen.
  // Deckt ab: "264.95€" in einem Textstueck, "264.95" + "€" als getrennte Stuecke, und "€" per CSS (::after/::before).
  var SYMBOL = { USD: '$', GBP: '£' }[d.currency] || '';
  var AMOUNT = '\\d{1,3}(?:[.,]\\d{3})*[.,]\\d{2}';
  var EURO_AMOUNT = new RegExp('^(\\s*)(?:€\\s?)?(' + AMOUNT + ')(?:\\s?€)?(\\s*)$');
  var ONLY_AMOUNT = new RegExp('^\\s*' + AMOUNT + '\\s*$');
  var ONLY_EURO = /^\s*€\s*$/;
  function textNodes(root, out) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = walker.nextNode())) out.push(n);
    root.querySelectorAll('*').forEach(function (el) { if (el.shadowRoot) textNodes(el.shadowRoot, out); });
    return out;
  }
  function pseudoEuro(el) {
    try {
      var a = getComputedStyle(el, '::after').content || '', b = getComputedStyle(el, '::before').content || '';
      return a.indexOf('€') !== -1 || b.indexOf('€') !== -1;
    } catch (e) { return false; }
  }
  function fixCurrency() {
    if (!SYMBOL || !document.body) return;
    var nodes = textNodes(document.body, []);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i], t = node.nodeValue, parent = node.parentElement;
      if (!t || (parent && /^(SCRIPT|STYLE|TEXTAREA)$/.test(parent.tagName))) continue;
      if (t.indexOf('€') !== -1) {
        var m = t.match(EURO_AMOUNT);
        if (m) { node.nodeValue = m[1] + SYMBOL + m[2] + m[3]; continue; }
        if (ONLY_EURO.test(t)) {                       // "€" als eigenes Stueck hinter einem Betrag
          for (var j = i - 1; j >= 0 && j >= i - 3; j--) {
            if (ONLY_AMOUNT.test(nodes[j].nodeValue || '')) {
              nodes[j].nodeValue = nodes[j].nodeValue.replace(/\S/, function (c) { return SYMBOL + c; });
              node.nodeValue = '';
              break;
            }
          }
        }
      } else if (ONLY_AMOUNT.test(t) && parent && !parent.hasAttribute('data-hos-cur') && pseudoEuro(parent)) {
        parent.setAttribute('data-hos-cur', '1');     // "€" kommt per CSS -> abschalten, Zeichen voranstellen
        node.nodeValue = node.nodeValue.replace(/\S/, function (c) { return SYMBOL + c; });
      }
    }
  }
  if (SYMBOL) {
    var st = document.createElement('style');
    st.textContent = '[data-hos-cur]::after,[data-hos-cur]::before{content:none!important}';
    document.head.appendChild(st);
  }
  function all() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(updateForm);
    fixCurrency();
    updateCart();
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('form[action*="/cart/add"]')) {
      var inp = f.querySelector('[name="id"]');
      if (inp && entry(inp.value) && blocked(inp.value)) { e.preventDefault(); e.stopImmediatePropagation(); updateForm(f); }
    } else if (onCart && f.matches('form[action$="/cart"]') && Object.keys(V).some(blocked) && e.submitter && e.submitter.name === 'checkout') {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', function () { setTimeout(all, 50); }, true);
  document.addEventListener('click', function () { setTimeout(all, 120); }, true);
  setInterval(all, 800);
  all();
})();
